import React from 'react';
import TestimonialsSection from '../../components/TestimonialsSection';
import CTASection from '../../components/CTASection';
import SEO from '../components/SEO';
import ErrorBoundary from '../components/ErrorBoundary';
const TestimonialsPage = () => {
  // Structured data for testimonials
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Client Testimonials | Legacy Lab Financial',
    description: 'Hear from our clients who have transformed their financial futures with Legacy Lab Financial.',
    url: 'https://legacylabfinancial.com/testimonials',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Review',
          reviewBody: "Within the past 6 months I've seen an 18% increase on my investment.",
          author: {
            '@type': 'Person',
            name: 'Shena'
          },
          itemReviewed: {
            '@type': 'Service',
            name: 'Legacy Lab Financial'
          }
        }
      }]
    }
  };
  return <>
      <SEO title="Testimonials" description="Hear from our clients who have transformed their financial futures with Legacy Lab Financial." structuredData={structuredData} data-id="element-490" />
      <div className="py-16 px-4 text-center" data-id="element-491">
        <h1 className="text-4xl sm:text-5xl font-bold" data-id="element-492">
          Client <span className="text-gradient" data-id="element-493">Testimonials</span>
        </h1>
        <p className="mt-6 max-w-3xl mx-auto text-lg text-gray-600" data-id="element-494">
          Hear from our clients who have transformed their financial futures
          with Legacy Lab Financial.
        </p>
      </div>
      <ErrorBoundary data-id="element-495">
        <TestimonialsSection data-id="element-496" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-497">
        <CTASection data-id="element-498" />
      </ErrorBoundary>
    </>;
};
export default TestimonialsPage;